import { Size } from '@ff-os/shared-utils/types/Size';
import { loadDOMImage } from 'ff-canvas';
import { createCanvas } from './createCanvas';
import { toBlob } from './toBlob';

export const resizeAndOrientImage = async (
    imageUrl: string,
    orientation: number,
    resolution: Size
) => {

    const { width: imageWidth, height: imageHeight } = resolution;

    const { width, height } = orientSize(resolution, orientation);

    const canvas = createCanvas(width, height);
    const ctx = canvas.getContext('2d')!;

    normalizeOrientationOf(ctx, orientation, imageWidth, imageHeight);

    const image = await loadDOMImage(imageUrl, 'anonymous');

    ctx.clearRect(0, 0, imageWidth, imageHeight);
    ctx.drawImage(image, 0, 0, imageWidth, imageHeight);

    URL.revokeObjectURL(imageUrl);

    return URL.createObjectURL(await toBlob(canvas));
};

const normalizeOrientationOf = (
    ctx: CanvasRenderingContext2D,
    orientation: number,
    width: number,
    height: number
) => {

    const transforms: any = {
        1: { flipX: false, flipY: false, moveX: 0, moveY: 0, angle: 0 },
        2: { flipX: true, flipY: false, moveX: width, moveY: 0, angle: 0 },
        3: { flipX: true, flipY: true, moveX: width, moveY: height, angle: 0 },
        4: { flipX: false, flipY: true, moveX: 0, moveY: height, angle: 0 },
        5: { flipX: true, flipY: false, moveX: 0, moveY: 0, angle: 270 },
        6: { flipX: false, flipY: false, moveX: height, moveY: 0, angle: 90 },
        7: { flipX: true, flipY: false, moveX: height, moveY: width, angle: 90 },
        8: { flipX: false, flipY: false, moveX: 0, moveY: width, angle: -90 }
    };

    const { flipX, flipY, moveX, moveY, angle } = transforms[orientation];

    const scaleX = flipX ? -1 : 1;
    const scaleY = flipY ? -1 : 1;

    ctx.translate(moveX, moveY);
    ctx.rotate(angle * Math.PI / 180);
    ctx.scale(scaleX, scaleY);
};

export const orientSize = (size: Size, orientation: number) => {

    const width = isInverse(orientation) ? size.height : size.width;
    const height = isInverse(orientation) ? size.width : size.height;

    return {
        width,
        height
    };
};

const isInverse = (orientation: number) => {
    return orientation > 4 && orientation < 9;
};